
import { API_URL } from '@/utils/constans';

export const agreementUrl = `${API_URL}/api/main/agreement`;

export const policyUrl = `${API_URL}/api/main/policy`;

export const rulesUrl = `${API_URL}/api/main/rules`;